<template>
  <div class="container-fluid">
    <div align="left">
      <el-input class="col-lg-3 col-md-4 col-sm-5 col-5" v-model="searchForm.name"
                placeholder="Crafties Name"></el-input>
      <el-input class="col-lg-3 col-md-4 col-sm-5 col-5" v-model="searchForm.id" placeholder="Crafties ID"></el-input>
      <el-button @click="search()">Search</el-button>
    </div>
    <div style="margin-bottom: 6px">
      <div>
        <div style="float: left;margin-top: 6px;margin-bottom: 6px">
          <b>{{total}}</b> Crafties
        </div>
        <div style="float: right;margin-top: 6px;margin-bottom: 6px">
          <span><b>{{devicetotal}}</b> QC Devices </span><el-button class="el-button--small el-button--primary" @click="editVisible=true">update</el-button>
        </div>
      </div>
      <el-table v-tb-height="{self:this}" ref="table" border :data="list" :height="height" empty-text="Temporarily no data">
        <el-table-column align="center" width="200px">
          <template slot-scope="scope">
            <el-image style="height:40px;" fit="scale-down" :src="scope.row.img">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline" style="font-size:40px"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="crafite_name" label="Name" width="250px"></el-table-column>
        <el-table-column align="center" prop="crafite_uuid" label="ID" width="250px">
          <template slot-scope="scope">
            {{scope.row.crafite_uuid.substring(2)}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="audio_url" label="Test Audio" >
          <template slot-scope="scope">
            <el-row type="flex" align="middle" justify="space-between">
                <el-col v-if="formData.audio_url != ''" :span="10" style="margin-left: 15px">
                    <audio :src="scope.row.audio_url" controls></audio>
                </el-col>
                <el-col :span="8">
                    <el-upload class="avatar-uploader" action="/api/v1/common/upload" accept=".mp3,.MP3" :show-file-list="false" :limit="1" :on-success="handleAudioSuccess">
                        <el-button style="margin-left: 20px" class="el-button--medium el-button--primary" @click="setcraftie(scope.row)">upload</el-button>
                    </el-upload>
                </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div align="right">
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="Update Test Device" 
      :visible.sync="editVisible" 
      width="450px" top="10vh"
      destroy-on-close 
      @close="editSucc">
      <WriteDevice v-if="editVisible" @dialogSucc="editSucc"></WriteDevice>
    </el-dialog>
  </div>
</template>

<script>
  import WriteDevice from './WriteDevice'
  export default {
    name: 'CraftieQA',
    components: {WriteDevice},
    data () {
      return {
        editVisible:false,
        list: [],
        searchForm: {
          name: '',
          id: ''
        },
        formData: {},
        chooseItem: null,
        pageIndex: 1,
        pageSize: 20,
        total: 0,
        devicetotal:0,
        height: 0,
      }
    },
    computed: {},
    created () {
      this.getData()
      this.getDevice()
    },
    mounted () {
    },
    methods: {
      setcraftie(row){
          this.chooseItem=row;
      },
      getDevice(){
        this.$api.rootV1.post('/web/admin/writecrafiteid/getdevice', {}, (res) => {
            this.devicetotal = res.data.length;
        })
      },
      getData () {
        this.formData.size = this.pageSize
        this.formData.page = this.pageIndex
        this.$api.rootV1.post('/web/craftie/get', this.formData, (res) => {
          this.list = res.data
          this.total = res.totalCount
        })
      },
      search () {
        this.formData.crafite_name = this.searchForm.name
        this.formData.crafite_uuid = this.searchForm.id
        this.getData()
      },
      handleAudioSuccess(res, file) {
        if (res.errcode == 0) {
            this.chooseItem.audio_url = res.data;
            let loading = this.$util.loading();
            this.$api.rootV1.post("/web/craftie/editor",this.chooseItem,
                (res) => {
                    this.$alert("Successfully modified!", "info", {
                        confirmButtonText: "confirm",
                        type: "success",
                        callback: (action) => {
                            this.getData()
                            loading.close();
                        },
                    });
                },
                (res) => {
                    this.$message.error("upload failed!");
                    loading.close();
                }
            );
        } else {
            this.$message.error("upload failed!");
        }
     },
     editSucc () {
        this.editVisible = false
        this.getDevice()
      },
      handleCurrentChange (val) {
        this.pageIndex = val
        this.getData()
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/craftieQA/CraftieQA.vue